<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between">
        <div class="mr-auto">
          <h6>拜访记录</h6>
        </div>
        <div>
          <a v-b-toggle.collapse-visit role="button" style="color: #606266">
            <i v-if="isShowPanel" class="fa fa-chevron-down" title="收起"></i>
            <i v-else class="fa fa-chevron-up" title="展开"></i>
          </a>
        </div>
      </div>
      <b-collapse v-model="isShowPanel" id="collapse-visit">
        <b-row>
          <b-col>
            <el-timeline style="padding: 0px" class="mt-3">
              <el-timeline-item
                v-for="(item, index) in tableData"
                :key="index"
                :icon="index === 0 ? 'el-icon-more' : ''"
                :type="index === 0 ? 'primary' : ''"
                :color="index === 0 ? '#0bbd87' : ''"
                :size="index === 0 ? 'large' : 'normal'"
                :timestamp="item.visitDate"
                placement="top"
              >
                <div>
                  <span style="font-size: 18px; color: #444444">{{
                    item.visitTitle
                  }}</span>
                  <br />
                  <span style="color: #007bff">{{ item.visitPerson }}</span>
                  <el-divider direction="vertical"></el-divider>
                  <span style="color: #444444"
                    >厂方人员：{{ item.scmPerson }}</span
                  >
                  <div class="mt-2" v-if="item.visitDescription">
                    <p
                      style="
                        font-size: 14px;
                        color: #606266;
                        white-space: pre-line;
                      "
                      v-html="item.visitDescription"
                    ></p>
                  </div>
                  <div class="mt-2" v-if="item.visitImageList">
                    <swiper :options="swiperOption">
                      <swiper-slide
                        v-for="(itemImage, index) in item.visitImageList"
                        :key="index"
                      >
                        <div class="swiper-zoom-container">
                          <img
                            :src="itemImage.scmImageUrl"
                            @click="imageView(index, item.visitImageList)"
                          />
                        </div>
                      </swiper-slide>
                      <div class="swiper-pagination" slot="pagination"></div>
                      <div class="swiper-button-prev" slot="button-prev">
                        <i class="fa fa-chevron-circle-left icon-font" />
                      </div>
                      <div class="swiper-button-next" slot="button-next">
                        <i class="fa fa-chevron-circle-right icon-font" />
                      </div>
                    </swiper>
                  </div>
                  <div
                    class="d-flex justify-content-between mt-2"
                    v-for="(itemScore, index) in item.listScore"
                    :key="index"
                  >
                    <div>
                      <span class="text-muted" style="font-size: 14px"
                        >Score By：</span
                      >
                      <span class="text-muted" style="font-size: 14px"
                        >{{ itemScore.scoreByName }} at
                        {{ itemScore.scoreTime }}
                      </span>
                    </div>
                    <div>
                      <span class="text-muted" style="font-size: 14px"
                        >Score：</span
                      >
                      <span style="font-size: 14px">{{
                        itemScore.score ? itemScore.score : '--'
                      }}</span>
                      <el-divider direction="vertical"></el-divider>
                      <a
                        style="color: #007bff"
                        @click="openVisitScore(itemScore)"
                        role="button"
                        >View detail</a
                      >
                    </div>
                  </div>
                </div>
              </el-timeline-item>
            </el-timeline>
          </b-col>
        </b-row>
      </b-collapse>
      <div v-show="false" ref="viewBigVisitImage" v-viewer="{ movable: true }">
        <img
          v-for="src in viewerImageList"
          :src="src.scmImageUrl"
          :key="src.scmImageCode"
        />
      </div>
    </b-card>
    <el-dialog
      :visible.sync="dialogVisible"
      width="950px"
      :modal="true"
      :show-close="true"
      :title="dialogTitle"
      top="10vh"
      center
    >
      <visit-score ref="score" />
    </el-dialog>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import VisitScore from './visitscore'
export default {
  components: { Swiper, SwiperSlide, VisitScore },
  props: {
    params: {
      default: null,
      type: Object
    },
    autoLoad: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    params: {
      handler() {
        if (this.autoLoad) {
          this.init(this.params)
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      isShowPanel: true,
      dialogTitle: '',
      dialogVisible: false,
      scmCode: '',
      tableData: [],
      swiperOption: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        loop: false,
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      viewerImageList: []
    }
  },
  computed: {},
  methods: {
    init(params) {
      this.getData(params)
    },
    getData(params) {
      this.isBusy = true
      this.$api
        .opaScmVisitListTimeLineApi(params)
        .then((res) => {
          this.isBusy = false
          this.tableData = res.body.data
          this.tableData.forEach((item) => {
            if (item.visitDescription !== null) {
              item.visitDescription = item.visitDescription
                .replace(/ /g, '&nbsp;')
                .replace(/\n/g, '<br/>')
            }
          })
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    // 点击大图显示图片预览组件
    imageView(index, imageList) {
      if (imageList.length > 0) {
        const viewer = this.$refs.viewBigVisitImage.$viewer
        this.viewerImageList = imageList
        viewer.view(index)
        viewer.show()
      }
    },
    openVisitScore(row) {
      let params = {
        visitScoreCode: row.visitScoreCode
      }
      this.getVisitScoreData(params)
    },
    getVisitScoreData(params) {
      this.isBusy = true
      this.$api
        .opaScmVisitscoreGetVisitScoreApi(params)
        .then((res) => {
          this.isBusy = false
          if (res.body != null) {
            this.dialogTitle = res.body.appraisalBillName
            this.popShow(res.body)
          } else {
            this.$message.warning('没有供应商评分记录')
            this.dialogVisible = false
          }
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    popShow(data) {
      setTimeout(() => {
        this.$refs.score.showData(data)
      }, 100)
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.swiper-button-next {
  right: 10px;
  margin-top: -1.2rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 100%;
  opacity: 0.3;

  &:hover {
    opacity: 0.9;
  }

  &::after {
    content: none;
  }
}

.swiper-button-prev {
  left: 10px;
  margin-top: -1.2rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 100%;
  opacity: 0.3;

  &:hover {
    opacity: 0.9;
  }

  &::after {
    content: none;
  }
}

.icon-font {
  font-size: 2.2rem;
}

.card {
  margin: 20px 10px;
}
</style>
